/** Compact relative/absolute label for listing cards (e.g. "Today", "3 days ago", "18 May 2026"). */
export function formatListingDate(value: string | null | undefined): string | null {
  if (value == null || String(value).trim() === '') return null;
  const normalized = String(value).trim().replace(' ', 'T');
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) return null;

  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfListed = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diffDays = Math.floor((startOfToday.getTime() - startOfListed.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays > 1 && diffDays < 7) return `${diffDays} days ago`;

  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function listingCreatedAt(row: {
  created_at?: string | null;
  createdAt?: string | null;
}): string | null {
  return row.created_at ?? row.createdAt ?? null;
}
